export default {
      id: "Icon--print-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--print",
      toString: function () {
        return this.url;
      }
    }